import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import appStatic from './appStatic/reducer';
import orderMeal from './orderMeal/reducer';
import orderMealALaCarte from './orderMealALaCarte/reducer';
import meal from './meal/reducer';
import footerInfo from './footerInfo/reducer';
import settings from './settings/reducer';
import subscriptions from './subscriptions/reducer';
import transactions from './transactions/reducer';
import giftCards from './giftCards/reducer';
import cards from './cards/reducer';

import { createBrowserHistory } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';

class Store {
  static _persistConfig = {
    key: 'root',
    storage,
    whitelist: ['appStatic'],
    // whitelist: [],
  };

  static _initialReducers = {
    appStatic,
    meal,
    footerInfo,
    orderMeal,
    orderMealALaCarte,
    settings,
    subscriptions,
    transactions,
    giftCards,
    cards,
  };

  static init(initialState = {}) {
    const { createReduxHistory, routerMiddleware, routerReducer } =
      createReduxHistoryContext({
        history: createBrowserHistory(),
      });

    const rootReducer = combineReducers({
      ...Store._initialReducers,
      router: routerReducer,
    });

    const persistedReducer = persistReducer(Store._persistConfig, rootReducer);

    const composeEnhancer =
      typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ !== 'undefined'
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true })
        : compose;

    const store = createStore(
      persistedReducer,
      initialState,
      composeEnhancer(applyMiddleware(thunk, routerMiddleware))
    );

    const history = createReduxHistory(store);

    history.listen(location => {
      console.log(`new location via ${location.action}`, location);
      window.scrollTo(0, 0);
    });

    const persistor = persistStore(store);
    // persistor.purge(); //
    return { store, persistor, history };
  }
}

export default Store.init();
